import React, { useContext, useMemo } from 'react';
import { InlineInputCardWrapper } from '@/features/editor/widgets/ai-component/inputs/shared/shared';
import { toCssDeclarationName } from '@/features/editor/widgets/ai-component/inputs/shared/css-declarations';
import { DropdownInputOption } from '@/features/editor/widgets/custom-widget/inputs/shared/dropdown';
import { SingleSelectInput } from '@/features/editor/widgets/ai-component/inputs/shared/single-select-input';
import { EditorContext } from '@/features/editor/context/editor-context';

export interface CssFontFamilyInputProps {
  name: string;
  initialValue: string;
  onChange: (name: string, value: string) => void;
}

export function CssFontFamilyInput({
  name,
  initialValue,
  onChange,
}: CssFontFamilyInputProps) {
  const displayName = useMemo(() => toCssDeclarationName(name), [name]);

  const {
    devicePreview: {
      editorState: { installedFonts },
    },
  } = useContext(EditorContext);

  const options: DropdownInputOption[] = useMemo(
    () => [
      ...installedFonts.map((font) => ({ label: font, value: font })),
      { label: `Roboto`, value: `Roboto` },
      { label: `Open Sans`, value: `"Open Sans"` },
      { label: `Fredoka`, value: `Fredoka` },
      { label: `Smooch Sans`, value: `"Smooch Sans"` },
      { label: `Rubik`, value: `Rubik` },
      { label: `Lato`, value: `Lato` },
      { label: `Poppins`, value: `Poppins` },
      { label: `Oswald`, value: `Oswald` },
      { label: `League Spartan`, value: `"League Spartan"` },
      { label: `Noto Sans`, value: `"Noto Sans"` },
      { label: `Raleway`, value: `Raleway` },
      { label: `Merriweather`, value: `Merriweather` },
      { label: `Playfair Display`, value: `"Playfair Display"` },
      { label: `Inter`, value: `Inter` },
      { label: `Jetbrains Mono`, value: `Jetbrains Mono` },
      { label: `Serif`, value: `serif` },
      { label: `Sans-Serif`, value: `sans-serif` },
      { label: `Monospace`, value: `monospace` },
      { label: `Inherit`, value: `inherit` },
    ],
    [],
  );

  const initOption = useMemo(
    () => options?.find((option) => option.value === initialValue),
    [initialValue],
  );

  const onValueChanged = (value: DropdownInputOption) => {
    if (onChange) {
      onChange(name, value.value);
    }
  };

  return (
    <InlineInputCardWrapper>
      <span>{displayName}</span>
      <SingleSelectInput
        options={options}
        initialValue={initOption}
        onChange={onValueChanged}
      />
    </InlineInputCardWrapper>
  );
}
